<template>
    <div>
        <Header :data_status="data_status"></Header>
        <div>
            <div class="card-block" v-show="data_status != 'loading'">
                <div class="inline" justify="between" valign="center">
                    <h1>Букинг #{{ $route.params.id }}<router-link class="button _free _second" to="/booking">К списку</router-link></h1>
                    <div class="inline" :status="request_status">
                        <div v-if="data.finished" class="text-accept">Завершено</div>
                        <div v-if="data.cancelled" class="text-decline">Отменено</div>
                        <div v-if="!data.finished && !data.cancelled" class="button _free _decline" @click="cancel()">Отменить</div>
                    </div>
                </div>

                <form class="card">
                    <div class="inline">
                        <div class="grid">
                            <div class="inline text-item">
                                <div class="text-item mini">
                                    <span>Номер</span>
                                    <p>{{ data.number }}</p>
                                </div>
                                <div class="text-item mini">
                                    <span>Тип авто</span>
                                    <p>{{ data.car_type }}</p>
                                </div>
                                <div class="text-item mini finance" v-if="data.price">
                                    <span>Сумма букинга</span>
                                    <p>{{ data.price | finance }}</p>
                                </div>
                            </div><br/>

                            <div class="text-item" v-if="data.check_in_time">
                                <span>Время check-in</span>
                                <p>{{ data.check_in_time }}</p>
                            </div>
                            <div class="text-item" v-if="data.check_out_time">
                                <span>Время check-out</span>
                                <p>{{ data.check_out_time }}</p>
                            </div>

                            <div class="inline text-item">
                                <div class="text-item mini">
                                    <span>Продолжительность</span>
                                    <p>{{ data.length }}</p>
                                </div>
                                <div class="text-item mini" v-if="data.units">
                                    <span>Юнитов</span>
                                    <p>{{ data.units }}</p>
                                </div>
                            </div><br/>

                            <div class="inline text-item">
                                <div class="text-item mini">
                                    <span>Время перестоя</span>
                                    <p>{{ data.length_overhead }}</p>
                                </div>
                                <div class="text-item mini finance" v-if="data.price_overhead">
                                    <span>Цена перестоя</span>
                                    <p>{{ data.price_overhead | finance }}</p>
                                </div>
                            </div><br/>

                            <div class="text-item mini finance" v-if="data.sum_overhead">
                                <span>Стоимость перестоя</span>
                                <p>{{ data.sum_overhead | finance }}</p>
                            </div>
                            <div class="text-item">
                                <span>Статус</span>
                                <p>{{ data.status_text }}</p>
                            </div>
                        </div>
                        <div class="grid">
                            <div class="text-item" v-if="data.time_start">
                                <span>Начало букинга</span>
                                <p>{{ data.time_start }}</p>
                            </div>
                            <div class="text-item" v-if="data.time_end">
                                <span>Конец букинга</span>
                                <p>{{ data.time_end }}</p>
                            </div>
                            <div class="text-item" v-if="data.time_till_start">
                                <span>Минут до начала букинга</span>
                                <p>{{ data.time_till_start }}</p>
                            </div>
                            <div class="text-item" v-if="data.time_actual_start">
                                <span>Фактическое время начала</span>
                                <p>{{ data.time_actual_start }}</p>
                            </div>
                            <div class="text-item" v-if="data.time_actual_end">
                                <span>Фактическое время окончания</span>
                                <p>{{ data.time_actual_end }}</p>
                            </div>
                        </div>
                        <div class="grid">
                            <div class="inline text-item" v-if="data.coupon">
                                <div class="text-item">
                                    <span>Купон</span>
                                    <p><router-link :to="'/coupon/' + data.coupon.id">{{ data.coupon.code }}</router-link></p>
                                </div>
                                <div class="text-item mini finance" v-if="data.coupon_sum">
                                    <span>Сумма</span>
                                    <p>{{ data.coupon_sum | finance }}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="inline mtop">
                        <div class="grid">
                            <h3>Пользователь</h3>
                            <div class="text-item" v-if="data.user">
                                <span>Пользователь</span>
                                <p><router-link :to="'/users/' + data.user.id">{{ data.user.email }}</router-link></p>
                            </div>
                            <div class="text-item" v-if="data.email">
                                <span>Email в букинге</span>
                                <p>{{ data.email }}</p>
                            </div>
                            <div class="text-item" v-if="data.phone">
                                <span>Телефон в букинге</span>
                                <p>{{ data.phone }}</p>
                            </div>
                        </div>
                        <div class="grid">
                            <h3>Парковка</h3>
                            <div class="text-item" v-if="data.parking">
                                <span>Парковка</span>
                                <p><router-link :to="'/parking/' + data.parking.id">{{ data.parking.address }}</router-link></p>
                            </div>
                            <div class="inline text-item">
                                <div class="text-item mini">
                                    <span>Бесплатные часы</span>
                                    <p>{{ data.hours_free }}</p>
                                </div>
                                <div class="text-item mini finance" v-if="data.parking_part">
                                    <span>Доля парковки</span>
                                    <p>{{ data.parking_part | finance }}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
                <div class="submit button _free" v-show="showButton" @click="update()">Сохранить</div>
            </div>
            <div class="page-load" v-show="data_status == 'loading'">
                <div class="inline" valign="center">
                    <img src="~@/assets/img/preloader.svg" class="preloader"> Загрузка
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Header from '@/components/Header.vue'

    export default {
        components: {
            Header,
        },
        data () {
            return {
                data: {},
                data_backup: false,
                data_status: 'init',
                request_status: '',
            }
        },
        computed: {
            showButton () {
                if (JSON.stringify(this.data) == this.data_backup) {
                    return false
                }
                return true
            }
        },
        created () {
            this.getData()
        },
        methods: {
            savedata () {
                this.data_backup = JSON.stringify(this.data)
            },
            cancel () {
                return new Promise((resolve, reject) => {
                    this.request_status = 'loading'
                    this.axios.post('api/admin/v2/booking/' + this.$route.params.id + '/cancel')
                        .then(() => {
                            this.request_status = ''
                            this.data.cancelled = true
                            this.savedata()
                            resolve()
                        })
                        .catch(() => {
                            this.request_status = ''
                            let msg = {
                                message: 'Ошибка при изменении статуса',
                                status: 'error'
                            }
                            this.$store.dispatch('utils/showMessage', msg)
                            reject()
                        })
                })
            },
            getData () {
                return new Promise((resolve) => {
                    this.data_status = 'loading'
                    this.axios.get('api/admin/v2/booking/' + this.$route.params.id)
                        .then(resp => {
                            this.data = resp.data.response
                            this.savedata()
                            this.data_status = ''
                            resolve()
                        })
                        .catch(() => {
                            this.$router.push('/booking')
                        })
                })
            }
        }
    }
</script>
